<script setup lang="ts">
import { PRODUCT_CATALOGUE_ROUTE } from "../../pages/produktkatalog/index.vue";

const { data } = useProducts("/aunivers");

const packet = inject(keys.currentPacket);

const products = computed(() => data.value?.filter((p) => p.id !== packet?.value?.id));
</script>

<template>
  <section class="bg-green-50 py-xl">
    <Content class="flex flex-col gap-l">
      <h2 class="text-center font-headline text-3xl font-normal leading-10 tracking-[1px] text-white">
        Flere digitale læringsunivers
      </h2>
      <ul class="grid grid-cols-1 gap-m xs:grid-cols-3">
        <li v-for="product in products" :key="product.id">
          <CardsRelated :product="toProductCard(product)" />
        </li>
      </ul>

      <PacketRelatedCta
        text="Se også hele utvalget vårt av bøker og læremidler"
        :link-to="{ name: PRODUCT_CATALOGUE_ROUTE }"
        link-label="Gå til produktkatalogen"
      />
    </Content>
  </section>
</template>
